import { defineStore } from 'pinia'
import { useAppStore } from './appStore'
import { useToast } from 'vuestic-ui'
import { api } from '../services/api'

export const useHomeStore = defineStore('home', {
  state: () => ({
    data: {
      loaded: false,
      total_billing_last_year: null,
      total_billing_year: null,
      total_comission_year: null,
      latest_orders: null,
      professionals_count: null,
      customers_count: null,
      products_count: null,
      orders_total_month: null,
      orders_total_last_month: null,
      orders_total_month_history: null,
    },
  }),

  actions: {
    async getHomeData() {
      const appStore = useAppStore()

      appStore.toggleLoading(true)

      try {
        const { data } = await api.get('/admin/home')

        this.data = {
          ...data,
          loaded: false,
        }

        this.data.loaded = true
      } catch (e: any) {
        const { init } = useToast()
        if (e?.response?.data?.message) {
          init({ message: e.response.data.message, color: 'danger' })
        } else {
          init({ message: e.message, color: 'danger' })
        }
      } finally {
        appStore.toggleLoading(false)
      }
    },
  },
})
